import { createContext, useContext, useState, useEffect } from 'react';
import { cms } from '../utils/api';

const CMSContext = createContext(null);

export function CMSProvider({ children }) {
  const [contenuti, setContenuti] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    cms.contenuti()
      .then(res => setContenuti(res.data || {}))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <CMSContext.Provider value={{ contenuti, loading }}>
      {children}
    </CMSContext.Provider>
  );
}

/**
 * Hook per leggere un contenuto CMS per slug.
 * Ritorna il valore dal CMS oppure il fallback (default = '').
 */
export function useCMS(slug, fallback = '') {
  const ctx = useContext(CMSContext);
  if (!ctx) return fallback;
  return ctx.contenuti[slug] ?? fallback;
}

/**
 * Hook per accedere a tutti i contenuti CMS (oggetto {slug: valore}).
 */
export function useCMSAll() {
  const ctx = useContext(CMSContext);
  return ctx ? ctx.contenuti : {};
}

export default CMSContext;
